'use strict';

export default {
  public: {
    controls: {
      yesNo: {
        yes: 'Yes',
        no: 'No',
        na: 'N/A',
      },
      acknowledgment: {
        text: 'Acknowledgment',
      },
    },
  },
};
